<template>
  <div class="filters">
    <template
      v-for="{
        type: filterType,
        name,
        col,
        label,
        placeholder,
        items,
        options,
        optionLabel,
        keyValue,
        min,
        max,
        postfix,
        isTall,
      } in filters"
    >
      <component
        :is="getComponent(filterType)"
        v-if="checkFilterAvailability({ type: filterType, options })"
        :id="`${type}-${name}`"
        :key="name"
        :value="activeFilters[name]"
        :name="name"
        :type="filterType"
        :label="label"
        :placeholder="placeholder"
        :items="items"
        :options="[
          ...(optionLabel && keyValue ? [{ [optionLabel]: 'Wszystkie', [keyValue]: null }] : []),
          ...(options ? options : []),
        ]"
        :option-label="optionLabel"
        :key-value="keyValue"
        :allow-empty="false"
        :min="min"
        :max="max"
        :postfix="postfix"
        :is-tall="isTall"
        separate-labels
        :class="[
          'filters__field',
          { 'filters__field--double': filterType === 'double' || col === 2 },
          { 'filters__field--spacer': filterType === 'spacer' },
        ]"
        @emitObject="onFilterChange"
      />
    </template>
  </div>
</template>

<script>
import { throttle } from 'lodash';
import { mapState, mapActions } from 'vuex';
import FormField from '~/components/Form/FormField';
import FormDoubleField from '~/components/Form/FormDoubleField';
import FormMultiselect from '~/components/Form/FormMultiselect';
import FormRange from '~/components/Form/FormRange';
import FormRadio from '~/components/Form/FormRadio';
import FormCheckbox from '~/components/Form/FormCheckbox.vue';

export default {
  name: 'Filters',
  components: {
    FormField,
    FormDoubleField,
    FormMultiselect,
    FormRange,
    FormRadio,
    FormCheckbox,
  },
  props: {
    filters: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    withoutStoreFilters: {
      type: Object,
      default: null,
    },
    defaultOrderStatus: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    ...mapState({
      activeFilters(state) {
        return this.withoutStoreFilters
          ? this.withoutStoreFilters
          : state[this.module][this.type].activeFilters;
      },
    }),
    module() {
      return ['orders', 'invoices', 'complaints', 'ordersToAcceptance'].includes(this.type)
        ? 'filters'
        : 'productsFilters';
    },
  },
  methods: {
    ...mapActions({
      changeFilters: 'filters/changeFilters',
      changeProductsFilters: 'productsFilters/changeFilters',
    }),
    checkFilterAvailability(filter) {
      if (filter.type !== 'select') return true;

      return filter.type === 'select' && filter?.options?.length;
    },
    getComponent(type) {
      if (type === 'spacer') return 'div';
      if (type === 'double') return 'FormDoubleField';
      if (type === 'select') return 'FormMultiselect';
      if (type === 'range') return 'FormRange';
      if (type === 'radio') return 'FormRadio';
      if (type === 'checkbox') return 'FormCheckbox';
      return 'FormField';
    },
    // eslint-disable-next-line space-before-function-paren
    onFilterChange: throttle(function ({ name, value }) {
      if (this.withoutStoreFilters) {
        this.$emit('changeFilter', { name, value });
      } else if (this.module === 'productsFilters') {
        this.changeProductsFilters({ type: this.type, name, value });
      } else {
        this.changeFilters({ type: this.type, name, value });
      }
    }, 1000),
  },
};
</script>

<style lang="scss">
.filters {
  display: flex;
  flex-wrap: wrap;
  margin-left: -1rem;
  margin-right: -1rem;
  margin-bottom: -1.5rem;

  @include rwd('small-tablet') {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  @include rwd('large-phone') {
    flex-direction: column;
  }

  &__field {
    margin-bottom: 1.5rem;
    flex: 0 0 25%;
    max-width: 25%;
    position: relative;
    padding-left: 1rem;
    padding-right: 1rem;

    @include rwd('large-tablet') {
      flex: 0 0 50%;
      max-width: 50%;
    }

    @include rwd('small-tablet') {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

    @include rwd('large-phone') {
      flex: 0 0 100%;
      max-width: 100%;
    }

    &--double {
      flex: 0 0 50%;
      max-width: 50%;

      @include rwd('large-tablet') {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }

    &--spacer {
      @include rwd('large-phone') {
        display: none;
      }
    }
  }
}
</style>
